import { customStyles, formatDateTime, LCADocumentsRequiredForPayment } from "helpers";
import Layout from "pages/Layout";
import PdfGenerateCertificate from "pages/pdftemplates/generateShipmentCertificate";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { makeGetRequest } from "request";
import loading from "../../../assets/images/loading.gif"
import Modal from "react-modal"

const CoCForShipment =  () => {
    const location = useLocation()
    const [isLoading, setIsLoading] = useState(false);
    const dataAfterNavigation = location.state as { shippingDocumentId: any, status: number };
    const [isShowingLCACertificate, setIsShowingLCACertificate] = useState(false);
    const [isShowingFFCertificate, setIsShowingFFCertificate] = useState(false);
    const [data, setData] = useState<Record<string, any>>({});

    const getShippingDocumentById = () => {
        setIsLoading(true);
        var request: Record<string, any> = {
          what: "getShippingDocumentById",
          id: dataAfterNavigation?.shippingDocumentId,
        };
    
        makeGetRequest(request)
          .then((response: any) => {
            setIsLoading(false);
            const res = response.data.data;
            setData(res);
          })
          .catch((error: any) => console.log(error.errorMessage));
    };   

    useEffect(() => {
        getShippingDocumentById();
        // eslint-disable-next-line
    }, []);
    
    const page = "Shipping Documents"
    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <div className="main-inner mt-2">                  
                        <div className="detail-top-section">
                            <Link
                                to="/transitofficer/shippingdocuments"
                                state={{ status: dataAfterNavigation?.status }}
                                className="actions"
                            >
                                <p>
                                    <span className="material-symbols-rounded">arrow_back</span>{" "}
                                    Back to Shipping Documents
                                </p>
                            </Link>                                              
                        </div>
                    </div> 
                    <div className="main-inner mt-1" style={{minHeight: "calc(100vh - 130px)", padding: "16px", boxSizing: "border-box"}}>
                        <div className="accordion">
                            <div
                                className={`header d-flex ${isShowingFFCertificate ? "active" : ""}`}
                                onClick={() => setIsShowingFFCertificate(!isShowingFFCertificate)}
                            >
                            <div className="d-flex">
                                <span className="material-symbols-rounded">
                                    {isShowingFFCertificate ? "expand_more" : "chevron_right"}
                                </span>
                                <span>Freight Forwarder Certificate of Shipment</span>
                            </div>
                            <p className="small-text m-0">
                                Created: {formatDateTime(data?.dateOfShipment)}
                            </p>
                            </div>
                            {isShowingFFCertificate && (
                                <div className="body">
                                    <PdfGenerateCertificate 
                                        key="1" 
                                        issuerInformation={data.shippingDocumentAttachments.find((attachment: any) => attachment.documentName === "Master_Bill_Of_Lading_Or_Air_Way_Bill")}                                        
                                        role={"FreightForwarder"} 
                                        data={{referenceNumber: data?.referenceNumber, companyName: data?.freightForwarder?.companyName, date: data?.dateOfShipment}} 
                                        isLoading={isLoading} />
                                </div>
                            )}
                        </div>
                        {(data?.localClearingAgentId 
                        && LCADocumentsRequiredForPayment.every((document: string) => data.shippingDocumentAttachments.some((attachment: any) => attachment.documentName === document && attachment.isApproved))) //to confirm if LCA has uploaded all documents required for payment
                        && <div className="accordion mt-1">
                            <div
                                className={`header d-flex ${isShowingLCACertificate ? "active" : ""}`}
                                onClick={() => setIsShowingLCACertificate(!isShowingLCACertificate)}
                            >
                            <div className="d-flex">
                                <span className="material-symbols-rounded">
                                    {isShowingLCACertificate ? "expand_more" : "chevron_right"}
                                </span>
                                <span>Local Clearing Agent Certificate of Delivery</span>
                            </div>
                            <p className="small-text m-0">
                                Created: {formatDateTime(data?.allDocumentApprovalDate)}
                            </p>
                            </div>
                            {isShowingLCACertificate && (
                                <div className="body">
                                    <PdfGenerateCertificate 
                                        key="1" 
                                        role={"LocalClearingAgent"} 
                                        data={{referenceNumber: data?.referenceNumber, companyName: data?.localClearingAgent?.companyName, date: data?.allDocumentApprovalDate}} 
                                        isLoading={isLoading} />
                                </div>
                            )}
                        </div>}                        
                    </div>
                </div>
                <Modal isOpen={isLoading} style={customStyles} className="modal modal-sm" ariaHideApp={false}>
                    <div className="loader">
                        <img src={loading} alt="loading" />
                        <p>Loading data...</p>
                    </div>
                </Modal> 
            </div>
        </Layout>
    )
}

export default CoCForShipment